// Interior Moderna — Custom JS
// Option C: Move wishlist heart inline with Add to Cart
// Uses MutationObserver for reliable timing with async Swish injection
(function() {
  'use strict';

  function initWishlistLayout() {
    // Don't run twice
    if (document.getElementById('atc-wishlist-row')) return true;

    var buyBtns = document.querySelector('buy-buttons');
    if (!buyBtns) return false;

    // Find the wishlist block specifically inside product-info
    var productInfo = document.querySelector('safe-sticky.product-info');
    if (!productInfo) return false;

    var wkBlock = productInfo.querySelector('.shopify-app-block .wk-button');
    if (!wkBlock) return false;

    // Get the actual shopify-app-block container
    var appBlock = wkBlock.closest('.shopify-app-block');
    if (!appBlock) return false;

    var vStack = buyBtns.parentElement;
    if (!vStack) return false;

    var wrapper = document.createElement('div');
    wrapper.id = 'atc-wishlist-row';
    vStack.insertBefore(wrapper, buyBtns);
    wrapper.appendChild(buyBtns);
    wrapper.appendChild(appBlock);
    return true;
  }

  // Strategy 1: Try immediately if DOM is ready
  if (document.readyState !== 'loading') {
    if (initWishlistLayout()) return;
  }

  // Strategy 2: Try on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    if (initWishlistLayout()) return;
  });

  // Strategy 3: MutationObserver — watches for Swish injecting its button
  var observer = new MutationObserver(function(mutations) {
    if (initWishlistLayout()) {
      observer.disconnect();
    }
  });

  // Start observing once DOM is available
  function startObserving() {
    var target = document.querySelector('safe-sticky.product-info') || document.body;
    observer.observe(target, { childList: true, subtree: true });

    // Safety timeout: stop observing after 15 seconds
    setTimeout(function() { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();

// Memorial Day homepage background wrapper.
// Keeps the existing Shopify sections/content intact while giving the dark grid,
// transition spacer, and story block one continuous background layer.
(function() {
  'use strict';

  function findSection(suffix) {
    return document.querySelector('[id$="__' + suffix + '"]');
  }

  function wrapMemorialDayBackground() {
    var media = findSection('media_grid_FdTpBB');
    var transition = findSection('im_mist_dark_to_light_1');
    var story = findSection('custom_html_wCT96G');

    if (!media || !transition || !story) return false;
    if (media.parentElement && media.parentElement.classList.contains('im-md-bg-stack')) return true;
    if (transition.parentElement && transition.parentElement.classList.contains('im-md-bg-stack')) return true;

    var parent = media.parentNode;
    if (!parent || transition.parentNode !== parent || story.parentNode !== parent) return false;

    var wrapper = document.createElement('div');
    wrapper.className = 'im-md-bg-stack';
    parent.insertBefore(wrapper, media);
    wrapper.appendChild(media);
    wrapper.appendChild(transition);
    wrapper.appendChild(story);
    return true;
  }

  function run() {
    if (wrapMemorialDayBackground()) return;

    var attempts = 0;
    var timer = window.setInterval(function() {
      attempts += 1;
      if (wrapMemorialDayBackground() || attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:reorder', run);
})();
